import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Text,
  Input,
  Select
} from "@chakra-ui/react";
import React from "react";
import isAllowed from "../../routing/isAllowed";

function NonCertStock() {
  return (
    <Box marginBottom={"3rem"}>
      <Grid templateColumns="repeat(3, 1fr)" marginTop={"5rem"}>
        <GridItem>
          <Text
            color={"#141D43"}
            fontSize="2xl"
            fontWeight={"800"}
            fontFamily={"font.roboto"}
          >
            Non-Certified Stock
          </Text>
          <Text color={" #3958DC"} fontSize="sm">
            Edit if necessary
          </Text>
        </GridItem>
        {/* <GridItem>
            <Input bgColor="white" placeholder="search" />
          </GridItem>
          <GridItem ml={"20"}>
            <Button bg={"#52BBFF"} color={"#fff"} w="130px">
              Add
            </Button>
          </GridItem> */}
      </Grid>
      {/* <Box marginTop="2rem">
            <Text
              color={"#141D43"}
              fontSize="2xl"
              fontWeight={"800"}
              fontFamily={"font.roboto"}
            >
              Add Procurement Details
            </Text>
            <Text color={" #3958DC"} fontSize="sm">
              Please fill necessary details
            </Text>
          </Box> */}
      <Box
        marginTop={"3.3rem"}
        bg={"#52BBFF"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft="-2rem"
        marginRight={"-2.5rem"}
      >
        Personal Details
      </Box>
      <Box mt="10">
        <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem colSpan={1}>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Product Name*
            </Text>
            <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
              Viscose
            </Text>
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Company Name*
            </Text>
            <Text color={"#464C64"} fontSize="sm" marginTop={"1rem"}>
              Dean Dayal Ichalkaranji
            </Text>
          </GridItem>
          <GridItem>
            <Box>
              <Button
                w="130px"
                bg="#52BBFF"
                color={"#fff"}
                _hover={{ bg: "#52BBFF" }}
              >
                Edit
              </Button>
            </Box>
          </GridItem>
        </Grid>
      </Box>
      <Box mt="10">
        <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Product Details
            </Text>
            <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
              T-shirt, Singlets
            </Text>
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Product Category
            </Text>
            <Text color={"#464C64"} fontSize="sm" marginTop={"1rem"}>
              Mens Garment
            </Text>
          </GridItem>
        </Grid>
      </Box>
      <Box mt="10">
        <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Product Composition
            </Text>
            <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
              Cotton 80% Organic
            </Text>
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Additional Claim
            </Text>
            <Text color={"#464C64"} fontSize="sm" marginTop={"1rem"}>
              Recycled
            </Text>
          </GridItem>
        </Grid>
      </Box>
      <Box mt="10">
        <Grid templateColumns="0.1fr 0.234fr 0.5fr" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Quantity
            </Text>
            <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
              100
            </Text>
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              UOM
            </Text>
            <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
              KG
            </Text>
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Transportation Details
            </Text>
            <Text color={"#464C64"} fontSize="sm" marginTop={"1rem"}>
              Road
            </Text>
          </GridItem>
        </Grid>
      </Box>
      <Box mt="10">
        <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Date
            </Text>
            <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
              12/12/22
            </Text>
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Time
            </Text>
            <Text color={"#464C64"} fontSize="sm" marginTop={"1rem"}>
              12:38PM
            </Text>
          </GridItem>
        </Grid>
      </Box>
      <Box mt="10">
        <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"} marginLeft={"2rem"}>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              Organisational Unit
            </Text>
            <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
              003
            </Text>
          </GridItem>
          <GridItem>
            <Text
              color={"#141D43"}
              fontSize="md"
              fontWeight={"700"}
              fontFamily={"font.roboto"}
            >
              GST No.
            </Text>
            <Text color={"#464C64"} fontSize="sm" marginTop={"1rem"}>
              GSTN0912345667
            </Text>
          </GridItem>
        </Grid>
      </Box>
      {/* <Box mt="10">
          <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
            <GridItem colSpan={1}>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                City
              </Text>
              <Text color={" #464C64"} fontSize="sm">
                Osmanabad
              </Text>
            </GridItem>
            <GridItem>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                State
              </Text>
              <Text color={"#464C64"} fontSize="sm">
                Maharashtra
              </Text>
            </GridItem>
          </Grid>
        </Box> */}
      {/* <Box
          marginTop={"1rem"}
          color={"#000000"}
          padding={"10px 2rem"}
          fontWeight="900"
          marginLeft="-2.3rem"
          marginRight={"-2.5rem"}
        >
          Farm Details
        </Box> */}
      {/* <Box mt="5">
          <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
            <GridItem colSpan={1}>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Land Size (Hectors)
              </Text>
              <Text color={" #464C64"} fontSize="sm">
                1.5
              </Text>
            </GridItem>
            <GridItem>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Cultivation Capacity (kg)
              </Text>
              <Text color={"#464C64"} fontSize="sm">
                1000
              </Text>
            </GridItem>
          </Grid>
        </Box> */}
      {/* <Box mt="10">
          <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
            <GridItem colSpan={1}>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Latitude
              </Text>
              <Text color={" #464C64"} fontSize="sm">
                27.2046° N
              </Text>
            </GridItem>
            <GridItem>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Longitude
              </Text>
              <Text color={"#464C64"} fontSize="sm">
                27.2046° N
              </Text>
            </GridItem>
          </Grid>
        </Box> */}
      {/* <Box
          marginTop={"1.5rem"}
          bg={"#52BBFF"}
          color={"#fff"}
          padding={"10px 2rem"}
          fontWeight="700"
          marginLeft="-2.4rem"
          marginRight={"-2.5rem"}
        >
          Procurement Details
        </Box> */}
      <Box>
        <Grid mt="10">
          <GridItem>
            {/* <Button
                  w="130px"
                  bg="#52BBFF"
                  color={"#fff"}
                  _hover={{ bg: "#52BBFF" }}
                >
                  Add
                </Button> */}
          </GridItem>
        </Grid>
      </Box>
      {/* <Box mt="10">
          <Grid templateColumns="repeat(8, 1fr)">
            <GridItem colSpan={1} ml="2">
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Program
              </Text>
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Procurement
              </Text>
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Net Weight
              </Text>
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                UOM
              </Text>
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Procurement Unit
              </Text>
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Vehical Number
              </Text>
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Date
              </Text>
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Text
                color={"#141D43"}
                fontSize="md"
                fontWeight={"700"}
                fontFamily={"font.roboto"}
              >
                Document
              </Text>
            </GridItem>
          </Grid>
          <Grid mt="5" templateColumns="repeat(8, 1fr)">
            <GridItem ml="2" colSpan={0.5}>
              <Select bgColor="white" color={" #464C64"} fontSize="sm">
                <option>NICE</option>
                <option>NICE</option>
              </Select>
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Input bgColor="white" placeholder="Cotton" />
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Input bgColor="white" placeholder="100" />
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Input bgColor="white" placeholder="kg" />
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Input bgColor="white" placeholder="Navi Mumbai" />
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Input bgColor="white" placeholder="MH43GL7002" />
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Input bgColor="white" placeholder="12/12/22" />
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Button textDecoration="underline">Upload</Button>
            </GridItem>
          </Grid>
          <Grid mt="5" templateColumns="repeat(8, 1fr)">
            <GridItem ml="2" colSpan={0.5}>
              <Select bgColor="white" color={" #464C64"} fontSize="sm">
                <option>NICE</option>
                <option>NICE</option>
              </Select>
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Input bgColor="white" placeholder="Cotton" />
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Input bgColor="white" placeholder="100" />
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Input bgColor="white" placeholder="kg" />
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Input bgColor="white" placeholder="Navi Mumbai" />
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Input bgColor="white" placeholder="MH43GL7002" />
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Input bgColor="white" placeholder="12/12/22" />
            </GridItem>
            <GridItem ml="2" colSpan={1}>
              <Button textDecoration="underline">Upload</Button>
            </GridItem>
          </Grid>
        </Box> */}
      {/* <Box>
          <Grid mt="7">
          <GridItem>
                <Button
                  w="130px"
                  bg="#52BBFF"
                  color={"#fff"}
                  _hover={{ bg: "#52BBFF" }}
                >
                  Submit
                </Button>
            </GridItem>
          </Grid>
        </Box> */}
    </Box>
  );
}

export default isAllowed(NonCertStock);
